import * as consts from './FloorplanConsts';

const initialState = {
    imagesPath: '',
    stages: [],
    activeStage: 0,
    mapPosition: {
        x: 0,
        y: 0
    },
    zoomStep: 0.05,
    zoom: 0.01,
    minZoom: 0.05,
    galleryVisible: true,
    autohideTriggered: false,
    autohideDisabled: false,
    visitedSlides: new Set([0]),
    activeSlideName: ''
};

const floorplan = (state = initialState, action) => {
    switch (action.type) {
        case consts.SET_ACTIVE_SLIDER:
            return {
                ...state,
                activeSlideName: action.payload.activeSlideName,
                visitedSlides: action.payload.visitedSlides,
                autohideDisabled: true
            }
        case consts.CHANGE_STAGE:
            return {
                ...state,
                activeStage: action.payload
            }
        case consts.SET_MAP_POSITION:
            return {
                ...state,
                mapPosition: action.payload.mapPosition
            }
        case consts.SET_ZOOM:
            return {
                ...state,
                zoom: action.payload
            }
        case consts.TOGGLE_VISIBILITY:
            return {
                ...state,
                galleryVisible: !state.galleryVisible,
                autohideDisabled: true
            }
        case consts.TRIGGER_AUTOHIDE:
            return {
                ...state,
                autohideTriggered: true
            }
        default:
            return state
    }
}

export default floorplan;
